var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntervention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 86C50 86 12 61 12 35C12 21 23 11 36 11C44 11 50 16 50 16C50 16 56 11 64 11C77 11 88 21 88 35C88 61 50 86 50 86Z",
    fill: "#ED727A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 51H36L43 37L52 65L60 51H81",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntervention);
export default __webpack_public_path__ + "static/media/intervention.a0f71e47e25c9a71692efe45c4519508.svg";
export { ForwardRef as ReactComponent };